const TELEVET_FEE = 5;

export default TELEVET_FEE;
